import { SnackbarKey, SnackbarMessage, useSnackbar } from "notistack";
import ToasterService from "utils/toaster.util";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function Toaster() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  const makeOptions = (variant: "success" | "error") => ({
    variant,
    content: (snackbarId: SnackbarKey, message: SnackbarMessage) => (
      <Box
        sx={{
          position: "relative",
          bgcolor: variant === "error" ? "#d32f2f" : "#43a047",
          color: "#fff",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
          borderRadius: 1.5,
          px: 2,
          py: 1.5,
          pr: isRTL ? 2 : 6,
          pl: isRTL ? 6 : 2,
          maxWidth: "calc(100vw - 32px)",
          // direction: isRTL ? "rtl !important" : "ltr !important",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: i18n.language === "ar" ? "arabic !important" : "arabic !important",
            fontWeight: 600,
            lineHeight: 1.4,
            wordBreak: "break-word",
            color: "#fff",
            textAlign: isRTL ? "right !important" : "left !important",
          }}
        >
          {message}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => closeSnackbar(snackbarId)}
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            [isRTL ? "left" : "right"]: 8,
            color: "#fff",
            p: 0.25,
            "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    ),
    anchorOrigin: {
      vertical: "bottom",
      horizontal: isRTL ? "left" : "right",
    } as const,
  });

  useEffect(() => {
    const success = (msg: string) =>
      msg && enqueueSnackbar(msg, makeOptions("success"));

    const error = (msg: string) =>
      msg && enqueueSnackbar(msg, makeOptions("error"));

    ToasterService.subscribe(success, error);

    return () => {
      ToasterService.subscribe(() => {}, () => {});
    };
  }, [enqueueSnackbar, i18n.language]);

  return null;
}
